import React from 'react';
import RSVPForm from './rsvp/RSVPForm';

function LiveRSVP({ weddingDate, startTime, endTime, fontP, walimatulurus, groomName, brideName, directions }) {

  return (
    <div>
      <RSVPForm
        weddingDate={weddingDate}
        startTime={startTime}
        endTime={endTime}
        fontP={fontP}
        walimatulurus={walimatulurus}
        groomName={groomName}
        brideName={brideName}
        directions={directions}
      />
    </div>
  );
}

export default LiveRSVP;
